var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.carrier)?_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"width":_vm.width(),"src":'/img/logos/' + _vm.carrier + '.svg'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }